import { createSlice } from "@reduxjs/toolkit";
import { AddShop, UpdateShop, GetShops } from "services/other/shop.service";
import { toast } from 'react-toastify';

export const shopListSlice = createSlice({
  name: "shopList",
  initialState: {
    shopList: [],
    shopListLoading: false,
    shopListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetShops.pending, (state) => {
      state.shopListLoading = true
    });

    builder.addCase(GetShops.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.shopList = action.payload
      state.shopListLoading = false
      state.shopListError = null
    });

    builder.addCase(GetShops.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.shopListLoading = false
      state.shopListError = action.error?.message
    });
  },
});

export const shopAddSlice = createSlice({
  name: "shopAdd",
  initialState: {
    shopAdd: {},
    shopAddLoading: false,
    shopAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddShop.pending, (state) => {
      // toast.loading('We are adding the Shop 🤯')
      state.shopAddLoading = true
    });

    builder.addCase(AddShop.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New shop added successfully 👌');

      state.shopAdd = action.payload
      state.shopAddLoading = false
      state.shopAddError = null
    });

    builder.addCase(AddShop.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the Shop 😣")

      state.shopAddLoading = false
      state.shopAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const shopUpdateSlice = createSlice({
  name: "shopUpdate",
  initialState: {
    shopUpdate: {},
    shopUpdateLoading: false,
    shopUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateShop.pending, (state) => {
      // toast.loading('We are updating the Shop 🤯')
      state.shopUpdateLoading = true
    });

    builder.addCase(UpdateShop.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Shop update successfully 👌');

      state.shopUpdate = action.payload
      state.shopUpdateLoading = false
      state.shopUpdateError = null
    });

    builder.addCase(UpdateShop.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the Shop 😣")

      state.shopUpdateLoading = false
      state.shopUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});
